// Service-specific checklists for quote requests

export const serviceChecklists = {
  'Plumbing': {
    title: 'What plumbing work do you need?',
    options: [
      'Fix leaking faucet or pipe',
      'Unclog drain or toilet',
      'Install new fixture (sink, toilet, etc.)',
      'Water heater repair/replacement',
      'Pipe repair or replacement',
      'Emergency plumbing issue',
      'Bathroom renovation plumbing',
      'Kitchen renovation plumbing',
      'Other plumbing work'
    ]
  },
  'Electrical': {
    title: 'What electrical work do you need?',
    options: [
      'Install new outlets or switches',
      'Electrical panel upgrade',
      'Light fixture installation',
      'Ceiling fan installation',
      'EV charger installation',
      'Rewiring (partial or full)',
      'Troubleshoot electrical issue',
      'Install smoke/carbon monoxide detectors',
      'Smart home wiring',
      'Other electrical work'
    ]
  },
  'Roofing': {
    title: 'What roofing work do you need?',
    options: [
      'Roof leak repair',
      'Complete roof replacement',
      'Shingle repair/replacement',
      'Roof inspection',
      'Gutter installation/repair',
      'Soffit and fascia repair',
      'Chimney flashing repair',
      'Roof ventilation',
      'Skylight installation/repair',
      'Other roofing work'
    ]
  },
  'HVAC': {
    title: 'What HVAC work do you need?',
    options: [
      'Air conditioner repair',
      'Furnace repair',
      'AC installation/replacement',
      'Furnace installation/replacement',
      'Duct cleaning',
      'Thermostat installation',
      'HVAC maintenance/tune-up',
      'Air quality improvement',
      'Heat pump service',
      'Other HVAC work'
    ]
  },
  'Snow Removal': {
    title: 'What snow removal service do you need?',
    options: [
      'Driveway snow clearing',
      'Walkway/sidewalk clearing',
      'Roof snow removal',
      'Ice management/salting',
      'Seasonal contract (recurring)',
      'One-time service',
      'Emergency snow removal',
      'Commercial property',
      'Residential property',
      'Other snow removal'
    ]
  },
  'Landscaping': {
    title: 'What landscaping work do you need?',
    options: [
      'Lawn mowing/maintenance',
      'Garden design/installation',
      'Tree/shrub planting',
      'Mulching/edging',
      'Sod installation',
      'Irrigation system installation',
      'Landscape lighting',
      'Hardscaping (patio, walkway)',
      'Spring/fall cleanup',
      'Other landscaping work'
    ]
  },
  'House Painting': {
    title: 'What painting work do you need?',
    options: [
      'Interior painting (walls)',
      'Interior painting (ceiling)',
      'Exterior house painting',
      'Trim and door painting',
      'Cabinet painting/refinishing',
      'Deck/fence staining',
      'Drywall repair before painting',
      'Wallpaper removal',
      'Color consultation',
      'Other painting work'
    ]
  },
  'Cleaning': {
    title: 'What cleaning service do you need?',
    options: [
      'Regular house cleaning',
      'Deep cleaning',
      'Move-in/move-out cleaning',
      'Post-construction cleaning',
      'Carpet cleaning',
      'Window cleaning',
      'Upholstery cleaning',
      'Office/commercial cleaning',
      'One-time service',
      'Recurring service'
    ]
  },
  'Handyman': {
    title: 'What handyman work do you need?',
    options: [
      'Furniture assembly',
      'TV mounting',
      'Door repair/installation',
      'Window repair',
      'Drywall repair',
      'Minor electrical repairs',
      'Minor plumbing repairs',
      'Shelving installation',
      'General home repairs',
      'Other handyman work'
    ]
  },
  'Renovation': {
    title: 'What renovation work do you need?',
    options: [
      'Kitchen renovation',
      'Bathroom renovation',
      'Basement finishing',
      'Room addition',
      'Complete home renovation',
      'Flooring installation',
      'Counter/backsplash installation',
      'Window/door replacement',
      'Framing/structural work',
      'Other renovation work'
    ]
  },
  'Pest Control': {
    title: 'What pest control service do you need?',
    options: [
      'Ants removal',
      'Rodent (mice/rats) removal',
      'Bed bug treatment',
      'Cockroach treatment',
      'Wasp/hornet nest removal',
      'Termite inspection/treatment',
      'Wildlife removal (raccoons, squirrels)',
      'Preventive pest control',
      'One-time treatment',
      'Ongoing pest management'
    ]
  },
  'Garage Doors': {
    title: 'What garage door work do you need?',
    options: [
      'Garage door repair',
      'Garage door installation',
      'Opener repair/replacement',
      'Spring replacement',
      'Track alignment',
      'Garage door maintenance',
      'Insulated door installation',
      'Smart opener installation',
      'Emergency service',
      'Other garage door work'
    ]
  }
};

// Get checklist for a service category
export const getChecklistForService = (serviceName) => {
  return serviceChecklists[serviceName] || {
    title: 'What work do you need done?',
    options: ['Please describe your project']
  };
};
